export default __webpack_public_path__ + "static/NBInternationalPro-Mono-6f693052175752c474c180c160479b1d.woff2";